/**
 * @fileoverview Generic text matching theme for numbers, letters, or any text labels.
 */

import { ThemeOptions } from '../../services/ThemeService.js';
import { ColorConfig, KonvaNode } from './BaseTheme.js';
import { ShapeHelpers } from '../ShapeHelpers.js';
import { TextMatchingTheme } from './TextMatchingTheme.js';
// import { EmojiCompatibility } from '../../utilities/EmojiCompatibility.js';

/**
 * Generic text matching theme with colored circle borders.
 * Used for numbers, letters, or any text-based matching.
 */
export abstract class EmojiMatchingTheme extends TextMatchingTheme {
    
    /**
     * Create a text matching theme.
     * Automatically filters out unsupported emojis on the current device.
     */
    constructor(id: string, name: string, labels: Array<string | number>, options: ThemeOptions = {}) {
        // Filter emoji labels to only include supported ones
        // const filteredLabels = EmojiCompatibility.filterSupported(
        //     labels.map(l => String(l)), 
        //     1000 // Minimum 5 emojis required
        // );
        
        // // Log filtering results for debugging
        // if (filteredLabels.length < labels.length) {
        //     console.log(`[${id}] Filtered emojis: ${labels.length} → ${filteredLabels.length} supported`);
        // }
        
        super(id, name, labels, options);
    }
    
    createShape(x: number, y: number, size: number, _color: ColorConfig, _isDraggable: boolean, label?: string | number): KonvaNode {
        const displayLabel = String(label || this.labels[0]);
        return ShapeHelpers.createEmojiText(x, y, size, displayLabel);
    }

}
